import { i_families, p_families } from './common'

export const i_roles_reg = [
    { id: 'admin', name: 'Amministratore' },
    { id: 'org_admin', name: "Amministratore ente"},
    { id: 'internal', name: 'Tecnico' },
    { id: 'external', name: 'Tecnico esterno' },
    { id: 'reviewer', name: 'Reviewer' },
    { id: 'superuser', name: 'Super Utente' },
    { id: 'online', name: 'Solo online' }
]

export const i_roles = {
    'admin': {
        'master': ['list', 'edit', 'remove'],
        'category': ['list', 'view', 'edit', 'remove'],
        'procedure': ['list', 'edit', 'view', 'remove'],
        'user': ['list', 'edit', 'remove'],
        'organism': ['edit', 'list', 'view', 'remove'],
        'primary': ['list', 'edit', 'view', 'remove'],
        'config': ['edit', 'view'],
        'operation': ['list', 'edit', 'remove', 'view', 'add_instr', 'close', 'open'],
        'client': ['list', 'edit', 'view', 'remove'],
        'location': ['list', 'edit', 'view', 'remove'],
        'instrument': ['list', 'edit', 'view', 'remove', 'operation', 'add_instr'],
        'report': ['edit_owner', 'edit', 'list', 'view', 'remove', 'remove_owner', 'revising', 'remove_admin', 'reopen'],
        'formulas': ['view', 'edit'],
        'pdf_generation': ['list', 'generate'],
        'home': ['statistic', 'operation', 'report']
    },
    'org_admin': {
        'master': ['list'],
        'category': ['list', 'view'],
        'procedure': ['list', 'view'],
        'user': ['view_org'],
        'organism': ['view_org'],
        'primary': ['view_org'],
        'config': ['view'],
        'operation': ['list', 'view_org'],
        'client': ['view_org'],
        'location': ['view'],
        'instrument': ['edit', 'view_org'],
        'report': ['list', 'view_org'],
        'formulas': ['view'],
        'pdf_generation': ['list'],
        'home': ['statistic', 'operation', 'report']
    },
    //     'master': ['list', 'view'],
    //     'category': ['list', 'view'],
    //     'procedure': ['list', 'view'],
    //     'user': ['view_org'],
    //     'organism': ['view_org'],
    //     'primary': ['view_org'],
    //     'config': ['view'],
    //     'operation': ['view_org'],
    //     'client': ['list', 'view_org'],
    //     'location': ['view'],
    //     'instrument': ['list', 'edit', 'view'],
    //     'report': ['view_org', 'edit', 'list'],
    //     'formulas': ['view'],
    //     'pdf_generation': ['list'],
    //     'home': ['statistic', 'operation', 'report']
    // },
    'internal': {
        'master': ['list', 'view'],
        'category': ['list', 'view'],
        'procedure': ['list', 'view'],
        'user': ['view_org'], //['list'],
        'organism': ['view_org'],
        'primary': ['view_org'], //['list', 'view'],
        'config': ['view'],
        'operation': ['view_owner', 'add_instr'], // 'view_org' ['list', 'edit', 'view'],
        'client': ['list', 'view'],
        'location': ['view'],
        'instrument': ['list', 'edit', 'view'],
        'report': ['view_owner', 'edit_owner', "remove_owner", 'revising'], // 'view_org' ['edit', 'list', 'view', "remove"],
        'home': ['operation', 'report']
    },
    'external': {
        'master': ['list'],
        'category': ['list', 'view'],
        'procedure': ['list', 'view'],
        'user': ['view_org'],
        'organism': ['view_org'],
        'primary': ['view_org'],
        'config': ['view'],
        'operation': ['view_owner', 'add_instr'], // ['view_org', 'edit'],
        'client': ['view_org'],
        'location': ['view_org'],
        'report': ['view_owner', 'edit_owner', 'remove_owner', 'revising'], //['view_org', 'edit', 'remove'],
        'instrument': ['view_org', 'edit'],
        'home': ['operation', 'report']
    },
    'reviewer': {
        'report': ['list', 'remove'],
        'review': ['list', 'review', 'remove'],
        'pdf_generation': ['list', 'generate']
    },
    'superuser': {
        'report_management': ['list', 'delete', 'edit_report_code'],
        'user': ['list', 'edit', 'remove', 'edit_report_seq'],
        'synchro': ['view']
    },
    'online': {
        
    }
}


export const i_report_permission_action = {
    'report_type': ['leg'], //, 'iso_simple', 'iso', 
    'report_instr': {}
}

/*
export const permission = {
    'report_type': ['iso', 'leg', 'iso_simple'],
    'report': {
        'edit', 'review', 'pdf_generation'
    }
    'primary: [list, edit],

    'master': ['create', 'edit', 'delete', 'activate'],
    'procedure: ['list', 'edit', 'remove'],
    'category': ['list', 'edit', 'remove'],
    'users': ['list', 'edit', 'remove'],
    'organism': [''edit, 'view'],
    'config': ['edit'],
    'instrument': ['edit', list],
    'operation': ['list', 'edit']
    'client': ['list', 'search']
}
*/

export function verifyPermission(obj_type, action, roles, permission) {
    let verified = false
        //console.log("obj_type", obj_type, 'action', action, roles, permission)
    try {
        if (Object.keys(roles).includes('superuser')) {
            verified = true
        } else {
            //console.log("**** OTHER - obj_type", obj_type, 'action', action)
            //console.log("**** ROLES - ", roles)
            if (typeof(action) === "string") {
                action = [action]
            }
            for (let role of roles) {
                let included = _.intersection(i_roles[role][obj_type], action)
                if (i_roles[role][obj_type] && included.length > 0) {
                    verified = true
                    break
                }
            }
        }
    } catch (e) {
        console.error('ERROR', e)
        console.error("DATA", obj_type, action, roles, permission)
        verified = false
    }
    //console.log("verified", verified)
    return verified
}

export function verifyReportPermission(action, op_type, family, roles, rep_permission, rev_permission) {
    let verified = false
    if (typeof(action) === "string") {
        action = [action]
    }

    for (let role of roles) {
        let included = _.intersection(i_roles[role]['report'], action)
        if (i_roles[role]['report'] && included.length > 0) {
            if (included.includes["review"]) {
                if (rev_permission[op_type] && rev_permission[op_type].enabled) {
                    // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
                    if (rev_permission[op_type].families.length == 0 || (rev_permission[op_type].families.length > 0 && rev_permission[op_type].families.includes(family))) {
                        verified = true
                        break
                    }
                }
            } else {
                if (rep_permission[op_type] && rep_permission[op_type].enabled) {
                    // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
                    if (rep_permission[op_type].families.length == 0 || (rep_permission[op_type].families.length > 0 && rep_permission[op_type].families.includes(family))) {
                        verified = true
                        break
                    }
                }
            }
        }
    }
    /*let included = _.intersection(["edit", "edit_owner", "remove", "remove_owner"], action)
    if (included.length > 0) {
        if (rep_permission[op_type] && rep_permission[op_type].enabled) {
            // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
            if (rep_permission[op_type].families.length == 0 || (rep_permission[op_type].families.length > 0 && rep_permission[op_type].families.includes(family))) {
                verified = true
            }
        }
    } else if (_.intersection(["review"], action).length > 0) {
        if (rev_permission[op_type] && rev_permission[op_type].enabled) {
            // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
            if (rev_permission[op_type].families.length == 0 || (rev_permission[op_type].families.length > 0 && rev_permission[op_type].families.includes(family))) {
                verified = true
            }
        }
    }*/
    return verified
}
export function filterByOrg(obj_type, action, roles) {
    let filter = false
    if (!Object.keys(roles).includes('superuser')) {
        for (let role of roles) {
            if (i_roles[role][obj_type] && i_roles[role][obj_type].includes(action)) {
                filter = true
                break
            }
        }
    }
    console.log('filterbyOrg',roles, roles.includes('admin'), filter)
    return filter
}

export function filterByUser(obj_type, action, roles) {
    let filter = false
    if (!Object.keys(roles).includes('superuser')) {
        for (let role of roles) {
            if (i_roles[role][obj_type] && i_roles[role][obj_type].includes(action)) {
                filter = true
                break
            }
        }
    }
    console.log('filterbyUser', filter)
    return filter
}


export function isSuperUser(roles) {
    return roles.includes('superuser')
}

export function filterFamilies(rep_type, permission) {

}

export function filterOpType(permission) {
    let op_fams = {}
    for (let p of Object.keys(permission)) {
        if (permission[p].enabled) {
            // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
            if (permission[p].families.length > 0) {

                op_fams[p] = permission[p].families
            } else if (permission[p].families.length == 0) {
                op_fams[p] = 'all'
            }
        }
    }
    console.log(op_fams)
    return op_fams
}

export function useRemoteConnection(roles) {
  // return false;
  return roles.includes("admin") || roles.includes("org_admin") || roles.includes("reviewer") || roles.includes("superuser") || roles.includes("online")
}

export function isAdmin(roles) {
    return roles.includes("admin")
}
export function isSupervisor(permissions, op_type, object) {
    return permissions.includes("supervisor")
}
export function isExternal(roles) {
    return roles.includes("external")
}
export function isInternal(roles) {
    return roles.includes("internal")
}
export function isOrgAdmin(roles) {
    return roles.includes("org_admin")
}
export function editPrimary(roles) {
    return roles.includes("admin") || roles.includes("org_admin")
}

export function getFamilies(primary) {
    //TODO to be extended with role control and specific returns
    if (!primary) {
        return i_families
    } else {
        let temp = p_families
        // temp['bilancia nawi'] = i_families['bilancia nawi']
        return temp
    }
}